import type { RxCollection } from 'rxdb';

/**
 * Look up a document by id and remove it, tolerating a not-yet-ready collection
 * or a missing doc. The single delete path behind every grid's confirmDelete.
 */
export async function removeById<T>(
    collection: RxCollection<T> | null,
    id: string
): Promise<void> {
    const doc = await collection?.findOne(id).exec();
    await doc?.remove();
}
